export const wampUrl = window.WAMP_URL || viteEnv("WAMP_URL");
export const natsUrl = window.NATS_URL || viteEnv("NATS_URL");
export const paymentUrl = window.PAYMENT_URL || viteEnv("PAYMENT_URL");
export const isCloud = asBool("IS_CLOUD" in window ? window.IS_CLOUD : viteEnv("IS_CLOUD"));
export const webappUrl = window.WEBAPP_URL || viteEnv("WEBAPP_URL");
export const authAPIUrl = window.AUTH_API_URL || viteEnv("AUTH_API_URL");
export const almauditAPIUrl = window.ALMAUDIT_API_URL || viteEnv("ALMAUDIT_API_URL");
export const tracerAPIUrl = window.TRACER_API_URL || viteEnv("TRACER_API_URL");
export const piserverApiUrl = window.PISERVER_API_URL || viteEnv("PISERVER_API_URL");
export const sentryDsn = window.SENTRY_DSN || viteEnv("SENTRY_DSN");
export const gtmId = window.GTM_ID || viteEnv("GTM_ID");
export const environment = window.ENVIRONMENT || viteEnv("ENVIRONMENT");
export const intercomId = window.INTERCOM_ID || viteEnv("INTERCOM_ID");
export const intercomApi = window.INTERCOM_API || viteEnv("INTERCOM_API");
export const amplitudeApiKey = window.AMPLITUDE_API_KEY || viteEnv("AMPLITUDE_API_KEY");
export const amplitudeDebug = window.AMPLITUDE_DEBUG || viteEnv("AMPLITUDE_DEBUG");
export const featureProxyUrl = window.FEATURE_PROXY_URL || viteEnv("FEATURE_PROXY_URL");
export const featureProxyClientId =
  window.FEATURE_PROXY_CLIENT_ID || viteEnv("FEATURE_PROXY_CLIENT_ID");
export const posthogApiKey = window.POSTHOG_PUBLIC_API_KEY || viteEnv("POSTHOG_PUBLIC_API_KEY");
export const posthogReverseProxy = window.POSTHOG_REVERSE_PROXY || viteEnv("POSTHOG_REVERSE_PROXY");
export const amplitudeReverseProxy =
  window.AMPLITUDE_REVERSE_PROXY || viteEnv("AMPLITUDE_REVERSE_PROXY");
export const recaptchaKey =
  window.RECAPTCHA_KEY || viteEnv("RECAPTCHA_KEY") || "6LeWkjQUAAAAAIFgzRm2gJMOMBxek8h6ozwuelbT";

// Runtime base path the app is served under (e.g. "/" or "/cockpit/").
// `import.meta.env.BASE_URL` is the build-time constant ("./"), which is no
// help for code that needs absolute URLs at runtime. Read it from
// <base href> via document.baseURI instead.
export const basePath = () => new URL(document.baseURI).pathname;

function viteEnv(key) {
  return import.meta.env["VITE_" + key];
}

function asBool(value) {
  return value === "true";
}
